/**
 * Created by ChrisMuto on 6/28/17.
 */
export const REQUEST_DEVICES = "REQUEST_DEVICES";
export const RECEIVE_DEVICES = "RECEIEVE_DEVICES";



// WEBPACK FOOTER //
// ./src/modules/devices/types.js